import { useEffect, useState } from 'react';
import { bulkAddNewLoopEntries } from "../../store/actions/client";
import { createNewRow, isTrueStringMatch } from "../utils";
import { useDispatch } from 'react-redux';
import { useReferenceData } from "./useReferenceData";
export const createPrefillRow = (entries,
// all entries for the row
reference_data_id,
// keyField's reference data id
headerIndexes // refData column by name indexes
) => row => {
  return createNewRow(entries.map(entry => {
    const {
      reference_data_column,
      reference_data_id: refDataId
    } = entry;
    const newEntry = {
      ...entry,
      preFillEntry: true
    };
    // we prefill any fields that are from the same file
    const rowIndex = headerIndexes[reference_data_column];
    if (headerIndexes && reference_data_column && isTrueStringMatch(reference_data_id, refDataId) && rowIndex !== undefined) {
      newEntry.value = row[rowIndex];
    }
    return newEntry;
  })).entries;
};
let sheetStore = {};
export const usePreFillRowsEffect = ({
  interactiveClient,
  shouldPrefill = false,
  limit = 180,
  // default limit
  sheet,
  entries,
  setLoadingState = () => {},
  // can be used for loaders
  shouldPrefillDuplicates = false
}, dependencies) => {
  const {
    id
  } = sheet;
  const [keyField] = entries;
  const {
    entry_values,
    reference_data_id,
    reference_data_column
  } = keyField;
  const dispatch = useDispatch();
  const [isMounted, setIsMounted] = useState(false);

  // this avoids initializeClientEntries from wiping out the prefilled entries
  useEffect(() => {
    setTimeout(() => {
      setIsMounted(true);
    }, 100);
    return () => setIsMounted(false);
  }, []);

  // will be empty arrays/no-op if no reference data
  const {
    rows,
    headers
  } = useReferenceData(reference_data_id);
  useEffect(() => {
    if (shouldPrefill && isMounted && !sheetStore[id]) {
      // keyfield created from reference data || project/code/customer
      if (reference_data_id && reference_data_column && rows.length) {
        const headerIndexes = Object.fromEntries(headers.map((str, index) => [str, index]));
        let newEntries = [];
        const seen = new Set();
        let currentIndex = 0;
        let uniqueRowCount = 0;

        // Keep processing rows until we either reach the limit or run out of rows
        while (uniqueRowCount < limit && currentIndex < rows.length) {
          const rowEntries = createPrefillRow(entries, reference_data_id, headerIndexes)(rows[currentIndex]);
          if (shouldPrefillDuplicates) {
            // shouldPrefillDuplicates is true, so we can add all entries
            newEntries.push(...rowEntries);
            uniqueRowCount++;
          } else {
            // Use the keyfield's reference data column to store unique values
            const row = rows[currentIndex];
            const keyFieldValue = row[headerIndexes[reference_data_column]];
            if (keyFieldValue && !seen.has(keyFieldValue)) {
              seen.add(keyFieldValue);
              newEntries.push(...rowEntries);
              uniqueRowCount++;
            }
          }
          currentIndex++;
        }
        dispatch(bulkAddNewLoopEntries({
          entries: newEntries
        }));
        setLoadingState(false);
        sheetStore[id] = true;
      } else if (!reference_data_id && !reference_data_column && entry_values.length) {
        setLoadingState(true);
        // keyfield created from dropdown options
        const newEntries = entry_values.slice(0, limit).reduce((acc, {
          text
        }) => {
          if (text) {
            acc.push(...createNewRow(entries.map((entry, index) => {
              if (index === 0) {
                return {
                  ...entry,
                  value: text,
                  preFillEntry: true
                };
              }
              return {
                ...entry,
                preFillEntry: true
              };
            })).entries);
          }
          return acc;
        }, []);
        dispatch(bulkAddNewLoopEntries({
          entries: newEntries
        }));
        setLoadingState(false);
        sheetStore[id] = true;
      }
    }
    return () => {
      if (!interactiveClient) {
        sheetStore = {};
      }
    };
  }, [...dependencies, rows, isMounted]); // should run, and sheet, adding rows
};